import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nl from './nl.json';
import en from './en.json';

/**
 * Two languages, Dutch by default (CO-0047). Every UI text comes from a key in nl.json and en.json; the language
 * follows the user's preference (admin.me) and is remembered locally until the profile is loaded.
 */
export const languages = ['nl', 'en'] as const;
export type Language = (typeof languages)[number];

const stored = (() => {
  try {
    return localStorage.getItem('mkcore.lang');
  } catch {
    return null;
  }
})();

void i18n.use(initReactI18next).init({
  resources: { nl: { translation: nl }, en: { translation: en } },
  lng: stored === 'en' ? 'en' : 'nl',
  fallbackLng: 'nl',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(lang: Language) {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    localStorage.setItem('mkcore.lang', lang);
  } catch {
    // Storage can be unavailable (private mode); the profile keeps the preference anyway.
  }
}

export default i18n;
